<style>
@import "./Treant.css";
</style>
<style scoped>
.badge-pill {
    border: 1px solid transparent;
    margin-right: 2px;
    border-color: #bbbbbb;
}
.badge-active {
    background: #466db2;
    border-color: #466db2;
    color: #fff;
}
</style>
<template>
    <div>
        <LoadingPlaceholder v-if="!loadedD" />
        <div v-if="loadedD">
            <Promised :pending-delay="null" :promise="rootUrlPromise">
                <template v-slot>
                    <component :is="'script'" :src="rapUrl" @load="loadedR = true"></component>
                    <component :is="'script'" :src="treUrl" @load="loadedT = true"></component>
                </template>
            </Promised>

            <div id="GuidedSearchContainer" class="container-fluid admin-content pb-0" role="main" aria-label="Home Page Editor">
                <div>
                    <div class="float-left">
                        <a @click.prevent="$emit('change-page', { page: 'AdminPage', settings: { areaUrlSlug: settings.areaUrlSlug, areaCode: settings.areaCode } })" :href="adminPageIndexUrl" class="back-link icon icon-arrow-left">Sites</a>
                        <h1 class="admin-content-heading mb-2">Home Page</h1>
                    </div>
                    <div style="float: right; position: relative">
                        <strong class="text-danger btn btn-bare btn-sm" v-show="mainTab == 'guided-search' && !isValid">Correct the error(s) indicated in red below</strong>
                        <div class="btn btn-bare btn-sm">
                            <AsyncOperationStatus :promise="savePromise" />
                        </div>
                        <template v-if="canEdit">
                            <button type="button" class="btn btn-primary btn-sm" name="action" value="Save" @click.prevent="save">Save</button>
                        </template>
                    </div>
                    <ul class="nav nav-tabs w-100" style="margin-bottom: 15px">
                        <li class="nav-item">
                            <a class="nav-link" tabindex="0" id="homeContentTab" :class="{ active: mainTab == 'home-content' }" @click.prevent="changeMainTab('home-content')">Content</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" tabindex="0" id="guidedSearchTab" :class="{ active: mainTab == 'guided-search' }" @click.prevent="changeMainTab('guided-search')">Guided Search</a>
                        </li>
                    </ul>
                </div>
                <div class="form-group gq_maincontent" v-show="mainTab === 'home-content'">
                    <div role="region" aria-label="Home Page Content Editor">
                        <DfTinyMceEditor class="htmlContent clearfix" v-model="landingPageHtml" :readonly="!canEdit" />
                    </div>
                </div>
                <div class="gq_container" v-show="mainTab === 'guided-search'">
                    <!-- <div id="gqLegend" class="tile" v-show="loaded">
            <a role="button" @click.prevent="showLegend = !showLegend">
                <h3 class="legend-heading" style="margin-bottom:2px;">Legend
                    <span class="float-right" :class="showLegend?['icon-close']:['']" style=""></span>
                </h3>
            </a>
            <div class="legend-body" :class="{collapse: !showLegend}">
                <strong class="d-block mt-2 mb-2">Questions</strong>
                <span class="legend-color legend-color-question">Question</span>
                <span class="legend-color legend-color-answer">Answer</span>
                <strong class="d-block mt-2 mb-2">Pages</strong>
                <span class="legend-color legend-color-web">Form</span>
                <span class="legend-color legend-color-pdf">PDF</span>
                <span class="legend-color legend-color-link">Link</span>
                <span class="legend-color legend-color-content">Content</span>
            </div>
        </div> -->
                    <LoadingPlaceholder v-show="!loaded" />
                    <div class="gq_box_container" v-show="loaded" role="region" aria-label="Guided Search Editor">
                        <template v-if="loadedT && loaded && mainTab === 'guided-search'">
                            <div class="gq_top_container" :id="containerId" v-treant="{ rootNode, click: clickNode, hasOtherTenantQuestions }" :class="currentlyEditing ? ['is_editing'] : []"></div>
                        </template>
                        <div class="gq_bottom_container" v-show="currentEditNode != null">
                            <div class="container-fluid">
                                <!-- form layout for an form editor -->
                                <div id="formEditor" v-if="isEditingForm">
                                    <div class="gq_editor_controls float-left w-100">
                                        <div class="change-text float-left">Change to a:&nbsp;&nbsp;</div>
                                        <div class="float-left">
                                            <button class="btn btn-outline-secondary btn-sm" @click.prevent="changeToQuestion" :disabled="!canEdit">New Question</button>
                                            <button class="btn btn-outline-secondary btn-sm" v-show="hasOtherTenantQuestions" @click.prevent="changeToQuestionLink" :disabled="!(canChangeToQuestionLink && canEdit)">Question Link</button>
                                        </div>
                                        <button class="btn btn-bare btn-sm icon icon-close float-right" @click.prevent="stopEditing">
                                            <span class="sr-only">Close</span>
                                        </button>
                                    </div>
                                    <form role="form" class="float-left w-100" @submit.prevent>
                                        <div class="row">
                                            <div class="col-sm-12">
                                                <div class="row" v-show="allowableTenants.length > 0">
                                                    <div class="col-sm-12">
                                                        <ul class="p-0" id="tenants">
                                                            <li class="badge badge-pill" :class="[hasSearchTenant(tenant) ? 'badge-active' : 'badge-light']" v-for="tenant in allowableTenants">
                                                                <a role="button" @click.prevent="toggleSearchTenant(tenant)" :disabled="!canEdit">
                                                                    <TenantDisplay :tenant="tenant" />
                                                                </a>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <!-- <div class="col-sm-12" v-show="allowableTags.length > 0">
                                            <ul class="p-0" id="tags">
                                                <li class="badge badge-pill" :class="[hasSearchTag(tag)?'badge-dark':'badge-light']" :disabled="!isTagEnabled(tag)" v-for="tag in allowableTags">
                                                    <a role="button" @click.prevent="toggleSearchTag(tag)" :disabled="!canEdit">{{ tag }}</a>
                                                </li>
                                            </ul>
                                        </div> -->
                                                    <div class="col-sm-12">
                                                        <div class="form-group">
                                                            <div class="input-group input-group-sm">
                                                                <label class="sr-only" for="formSearchBar">Filter Items</label>
                                                                <input type="search" class="form-control" id="formSearchBar" placeholder="Filter..." v-model="searchFormsTextInput" />
                                                                <!-- <span class="input-group-append">
                                                        <button type="button" class="btn btn-outline-secondary icon-search" @click.prevent="searchForms">
                                                            <span class="sr-only">Search</span>
                                                        </button>
                                                    </span> -->
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-sm-12">
                                                        <div class="list-group">
                                                            <button class="list-group-item text-left" :data-form-type="form.formTypes" :class="{ selected: cqFormNodeCast(currentEditNode).formName == form.formName && cqFormNodeCast(currentEditNode).formVersion == form.formVersion }" v-for="form in filteredPages" @click.prevent="setForm(form)" :disabled="!canEdit">
                                                                <div :disabled="!canEdit" style="display: block">
                                                                    <strong>{{ form.label }}</strong>
                                                                    <span class="badge badge-light" v-show="form.tenant != tenant">
                                                                        <TenantDisplay :tenant="form.tenant" />
                                                                    </span>
                                                                    <!--
                                                        <span class="color-indicators" v-show="tab == 'form' || tab == null">
                                                            <span :data-indicator="type" :title="currentEditNode.formTypeTitleAttr(type)" v-for="type in form.formTypes"></span>
                                                        </span>
                                                        -->
                                                                </div>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>

                                <!-- form layout for an other tenant question editor -->
                                <div id="formEditor" v-if="isEditingLinkedQuestion">
                                    <div class="gq_editor_controls float-left w-100">
                                        <div class="change-text float-left">Change to a:&nbsp;&nbsp;</div>
                                        <div class="float-left">
                                            <button class="btn btn-outline-secondary btn-sm" disable="!canEdit" @click.prevent="changeToQuestion">New Question</button>
                                            <button class="btn btn-outline-secondary btn-sm" disable="!(canChangeToForm && canEdit)" @click.prevent="changeToForm">Link</button>
                                        </div>
                                        <button class="btn btn-bare btn-sm icon icon-close float-right" @click.prevent="stopEditing">
                                            <span class="sr-only">Close</span>
                                        </button>
                                    </div>
                                    <form role="form" class="float-left w-100">
                                        <div class="row">
                                            <!--
                                <div class="col-sm-12">
                                    <ul class="pills" id="tags" data-bind="foreach: $parent.allowableTags">
                                        <li data-bind="css: { active: $parents[1].hasSearchTag($data) }"><button data-bind="text: $data, click: function() { $parents[1].toggleSearchTag($data); }, attr: { disabled: $root.canEdit() ? null : 'disabled'}"></a></li>
                                    </ul>
                                </div>
                                <div class="col-sm-12">
                                    <div class="form-group">
                                        <div class="input-group">
                                            <input type="search" class="form-control" id="formSearchBar" placeholder="Search..." data-bind="textInput: $root.searchFormsTextInput, valueUpdate: 'afterkeydown', enterKey: $root.searchForms, enable: $root.canEdit" />
                                            <span class="input-group-append">
                                                <button type="button" class="btn btn-outline-secondary" data-bind="click: $root.searchForms, attr: { disabled: $root.canEdit() ? null : 'disabled'}">
                                                    <span class="icon icon-search"></span>
                                                    <span class="sr-only">Search</span>
                                                </button>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                -->
                                            <div class="col-sm-12">
                                                <div class="list-group">
                                                    <div class="list-group-item" v-for="question in otherTenantQuestions" :class="{ selected: cqLinkedQuestionNodeCast(currentEditNode).link?.tenant == question.tenant && cqLinkedQuestionNodeCast(currentEditNode).link?.id == question.id }" @click.prevent="setLinkedQuestion(question)">
                                                        <button class="btn btn-link" style="padding: 0" :disabled="!canEdit" @keypress.enter.prevent="setLinkedQuestion(question)">
                                                            <div :disabled="!canEdit" style="display: block">
                                                                <strong>{{ question.questionText }}</strong>
                                                                <span class="badge badge-light" v-show="question.tenant != tenant">
                                                                    <TenantDisplay :tenant="question.tenant" />
                                                                </span>
                                                            </div>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>

                                <!-- form layout for a question editor -->
                                <div id="questionEditor" v-if="isEditingQuestion">
                                    <div class="gq_editor_controls float-left w-100">
                                        <div class="change-text float-left">Change to a:&nbsp;&nbsp;</div>
                                        <div class="float-left">
                                            <button class="btn btn-outline-secondary btn-sm" @click.prevent="changeToForm" :disabled="!(canChangeToForm && canEdit)">Link</button>
                                            <button class="btn btn-outline-secondary btn-sm" v-show="hasOtherTenantQuestions" @click.prevent="changeToQuestionLink" :disabled="!(canChangeToQuestionLink && canEdit)">Question Link</button>
                                        </div>
                                        <button class="btn btn-bare btn-sm icon icon-close float-right" @click.prevent="stopEditing">
                                            <span class="sr-only">Close</span>
                                        </button>
                                    </div>
                                    <form role="form" class="form-horizontal float-left w-100">
                                        <div class="row">
                                            <div class="col-sm-12">
                                                <div class="form-group">
                                                    <label for="question">Question</label>
                                                    <div>
                                                        <input class="form-control form-control-sm" type="text" id="question" :readonly="!canEdit" v-model="cqQuestionNodeCast(currentEditNode).questionText" />
                                                    </div>
                                                </div>

                                                <div>
                                                    <div class="form-row form-group admin_gq_answer" v-for="(answer, answerIndex) in cqQuestionNodeCast(currentEditNode).answers">
                                                        <div class="col-sm-11 offset-sm-1">
                                                            <label :for="'answer_' + answerIndex">Answer {{ answerIndex + 1 }}</label>
                                                            <div class="input-group input-group-sm mb-1">
                                                                <input type="text" class="form-control" v-model="answer.answerText" :id="'answer_' + answerIndex" :readonly="!canEdit" />
                                                                <span class="input-group-append" :disabled="!(canEdit && canRemoveAnswer(answer))" @click.prevent="removeAnswer(answer)">
                                                                    <button class="btn btn-outline-secondary icon icon-trash" title="Delete" :disabled="!(canEdit && canRemoveAnswer(answer))">
                                                                        <span class="sr-only">Delete Answer</span>
                                                                    </button>
                                                                </span>
                                                            </div>
                                                            <label :for="'answerHelpText_' + answerIndex" class="control-label mb-1">Help Text {{ answerIndex + 1 }}</label>
                                                            <textarea class="form-control w-100 form-control-sm" style="min-height: 60px" v-model="answer.helpText" :readonly="!canEdit" :id="'answerHelpText_' + answerIndex"></textarea>
                                                        </div>
                                                    </div>
                                                </div>
                                                <br />
                                                <div class="text-center form-group">
                                                    <button class="btn btn-outline-secondary btn-sm" @click.prevent="addAnswer" :disabled="!canEdit">
                                                        <span class="plus-sign">+</span>
                                                        Answer
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- TODO - Actually make responsive
        <meta name="viewport" content="width=1000" />
    --></div>
</template>
<script lang="ts">
// @ts-expect-error
import rapUrl from "!!file-loader!./raphael.js";
//@ts-expect-error
import treUrl from "!!file-loader!./Treant.js";
import { computed, createApp, defineComponent, nextTick, onActivated, onBeforeMount, onDeactivated, ref, getCurrentInstance, SetupContext, DirectiveBinding, ComponentInternalInstance } from "vue";
import { useMainStore } from "@/mainStore";
import generateGuid from "@/lib/generateGuid";
import distinct from "@/lib/distinct";
import { Promised } from "@/lib/Promised";
import TenantDisplay from "./TenantDisplay.3.vue";
import AsyncOperationStatus from "@/lib/AsyncOperationStatus.3.vue";
import TreeNode from "./TreeNode.3.vue";
import LoadingPlaceholder from "@/lib/LoadingPlaceholder.3.vue";
import { throwIfNonSuccessStatus } from "@/lib/fetchHelpers.3";
import { getXsftHeader } from "@/lib/getXsrfToken.3";
import { computedAsync } from "@vueuse/core";
import getData from "../../lib/getData";
import DfTinyMceEditor from "@/lib/DFTinyMceEditor.3.vue";
import { FormListItem } from "@cs-ts/form-list-item";
import { FormNode as FormNodeTS } from "@cs-ts/form-node";
import { FormNode as FormNodeCS } from "@cs/FormNode";
import { QuestionNode } from "@cs/QuestionNode";
import { QuestionLinkNode } from "@cs/QuestionLinkNode";
import { AnswerNode } from "@cs/AnswerNode";

import { CQActionTemplateNode, CQAnswerNode, CQQuestionNode, CQLinkedQuestionNode, CQFormNode } from "./nodes";
const chartConfig = {
    container: "#sandbox",
    levelSeparation: 15,
    animation: {
        nodeAnimation: "easeOutBounce",
        nodeSpeed: 500,
        connectorsAnimation: "bounce",
        connectorsSpeed: 500,
    },
    collapsable: false,
    rootOrientation: "WEST",
    connectors: {
        type: "bCurve",
    },
    node: {
        //HTMLclass: "gq_node"
    },
};
function applyChanges(element: HTMLElement, binding: DirectiveBinding) {
    const rootNode = binding.value.rootNode;
    const clickFunc = binding.value.click;
    const hasOtherTenantQuestions = binding.value.hasOtherTenantQuestions;
    const nodeStructure = rootNode.convertToTreantStruct();
    const config = {
        chart: chartConfig,
        nodeStructure: nodeStructure,
    };
    // @ts-expect-error
    const chartObj = window.TreeStore.createTree(config);
    const chartId = generateGuid();
    element.dataset.chartId = chartId;
    treantData[chartId] = chartObj;

    for (let item of Array.from(element.getElementsByClassName("ko_node"))) {
        const id = item.id;
        const node = rootNode.findNode(id);
        const itemApp = createApp(
            { ...TreeNode },
            {
                clickFunc: clickFunc.bind(null, node),
                node,
                defaultTenantCode: rootNode.tenant,
                hasOtherTenantQuestions,
            },
        );
        itemApp.mount(item.firstChild as Element);
    }

    nextTick(() => {
        for (let i = 0, len = chartObj.nodeDB.db.length; i < len; i++) {
            const node = chartObj.nodeDB.get(i);
            node.width = node.nodeDOM.offsetWidth;
            node.height = node.nodeDOM.offsetHeight;
        }
        interface DBNode {
            nodeHTMLid: string;
            nodeDOM: Element;
        }
        const positionTreeCallback = () => {
            const instance = binding.instance as any; // eslint-disable-line @typescript-eslint/no-explicit-any
            if (instance.currentlyEditing) {
                const nodeToScroll = chartObj.nodeDB.db.find((node: DBNode) => node.nodeHTMLid == instance.currentEditNode.vmId).nodeDOM;
                const scrollX = nodeToScroll.offsetLeft - element.clientWidth / 2;
                const scrollY = nodeToScroll.offsetTop - element.clientHeight / 2;
                element.scrollTo(scrollX, scrollY);
            }
        };
        chartObj.positionTree(positionTreeCallback);
    });
}
type CustomNode = CQActionTemplateNode | CQAnswerNode | CQQuestionNode | CQLinkedQuestionNode | CQFormNode;
type AvailablePage = FormListItem & FormNodeTS;
//const availablePages = [new CQFormNode(generateGuid(), "FN1", "FV1", "default", ["webForm"], "Form One", "This is form one.", ["One", "Form"]), new CQFormNode(generateGuid(), "FN2", "FV2", "default", ["webForm"], "Form Two", "This is form two.", ["Form"]), new CQFormNode(generateGuid(), "FN3", "FV3", "default", ["webForm", "pdfForm"], "Form Three", "This is form three.", ["Three", "Form"]), new CQFormNode(generateGuid(), "FN4", "FV4", "othertenant", ["pdfForm", "link"], "Form Four", "This is form four.", []), new CQFormNode(generateGuid(), "FN4", "FV4", "default", ["content"], "Content One", "This is content one.", []), new CQFormNode(generateGuid(), "FN5", "FV5", "default", ["content"], "Content Two", "This is content two.", []), new CQFormNode(generateGuid(), "FN6", "FV6", "default", ["contact"], "Contact One", "This is contact one.", []), new CQFormNode(generateGuid(), "FN7", "FV7", "default", ["contact"], "Contact Two", "This is contact two.", [])];
const treantData: Record<string, any> = {}; // eslint-disable-line @typescript-eslint/no-explicit-any
interface Props {
    settings: {
        areaUrlSlug: string;
        areaCode: string;
    };
}
export default defineComponent({
    emits: ["change-page"],
    props: ["settings"],
    //eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO - figure out why SetupContext gives overload failure
    setup(props: Props, setupContextUntyped: any) {
        const emit = (setupContextUntyped as SetupContext).emit;
        const mainStore = useMainStore();
        const instance = (getCurrentInstance() as ComponentInternalInstance).proxy!;
        const isInitialCreate = ref<boolean>(true);
        const loadedD = ref<boolean>(false);
        const loadedR = ref<boolean>(true);
        const loadedS = ref<boolean>(true);
        const loadedT = ref<boolean>(true);
        const landingPageHtml = ref<string>("<div><h1>Test</h1></div>");
        const otherTenantQuestions = ref<CQQuestionNode[]>([]);
        const rootNode = ref<CustomNode | null | undefined>(null); // eslint-disable-line @typescript-eslint/no-explicit-any
        const availablePages = ref<AvailablePage[]>([]);
        const canEdit = ref<boolean>(false);
        const mainTab = ref<string>("home-content");
        const tab = ref<string>("form");
        const showLegend = ref<boolean>(false);

        const currentEditNode = ref<CustomNode | null>(null);
        const selectedTags = ref<string[]>([]);
        const selectedTenants = ref<string[]>([]);
        const searchFormsTextInput = ref<string | null>(null);
        const searchFormsText = ref<string | null>(null);
        const savePromise = ref<Promise<void> | null>(null);

        const adminUrl = computedAsync(() => {
            return mainStore.getUrl("admin");
        });
        const adminPageIndexUrl = computedAsync(() => {
            return mainStore.getUrl("adminPageIndex", { areaUrlSlug: props.settings.areaUrlSlug, areaCode: props.settings.areaCode });
        });

        const loaded = computed(() => {
            return loadedS.value && loadedR.value && loadedT.value && loadedD.value;
        });
        const containerId = computed(() => {
            return chartConfig.container.substring(1);
        });
        const rootUrlPromise = computed(() => {
            // TODO - silly
            return mainStore.getUrl("index", { tenantUrlSlug: "foo" }).then(i => i.replace("foo", ""));
        });
        const tenant = computed(() => {
            return mainStore.tenantCode;
        });
        const hasOtherTenantQuestions = computed(() => {
            return otherTenantQuestions.value.length > 0;
        });
        const allowableTags = computed(() => {
            return distinct(
                Array.prototype.concat.apply(
                    [],
                    availablePages.value.map(i => i.tags),
                ),
            );
            //return distinct(Array.prototype.concat.apply([], tagPages.value.map(i => i.tags)));
        });
        const allowableTenants = computed(() => {
            return distinct(availablePages.value.map((i: AvailablePage) => i.tenant));
        });
        const currentlyEditing = computed(() => {
            return currentEditNode.value != null;
        });
        const isEditingQuestion = computed(() => {
            return currentEditNode.value != null && currentEditNode.value.type == "Question";
        });
        const isEditingForm = computed(() => {
            return currentEditNode.value != null && currentEditNode.value.type == "Form";
        });
        const isEditingLinkedQuestion = computed(() => {
            return currentEditNode.value != null && currentEditNode.value.type == "LinkedQuestion";
        });
        const canChangeToForm = computed(() => {
            return currentEditNode.value != null && currentEditNode.value.parent != null;
        });
        const canChangeToQuestionLink = computed(() => {
            return currentEditNode.value != null && currentEditNode.value.parent != null;
        });
        const filteredPages = computed(() => {
            let result = availablePages.value; // tagPages.value;

            var searchText = searchFormsTextInput.value;
            if (searchText) {
                const _contain = function (a: string | null | undefined, b: string | null | undefined) {
                    return a == null || b == null ? false : a.toUpperCase().indexOf(b.toUpperCase()) >= 0;
                };
                result = result.filter(v => _contain(v.label, searchText!) || _contain(v.description, searchText!));
            }
            if (selectedTags.value.length > 0) {
                result = result.filter(v => selectedTags.value.every(i => v.tags.includes(i)));
            }
            if (selectedTenants.value.length > 0) {
                result = result.filter(v => selectedTenants.value.some(i => v.tenant == i));
            }
            return result;
        });
        const isValid = computed(() => {
            return rootNode.value == null || rootNode.value.isValid();
        });

        const init = async () => {
            mainTab.value = "home-content";
            //tab.value = 'form';
            showLegend.value = false;
            loadedD.value = false;
            const homepageData = await getData(
                mainStore,
                "AdminGuidedSearch",
                () => mainStore.getUrl("adminGuidedSearchData", { areaUrlSlug: props.settings.areaUrlSlug, areaCode: props.settings.areaCode }),
                async data => {
                    const areaCode = props.settings.areaCode || (await mainStore.getTenantCodeByUrlSlug([props.settings.areaUrlSlug])[props.settings.areaUrlSlug]);
                    return data.AreaCode == areaCode;
                },
            );
            canEdit.value = homepageData.CanEdit;
            landingPageHtml.value = homepageData.LandingPageHtml;
            type ConvertNode = FormNodeCS & QuestionNode & QuestionLinkNode & { Id: string };
            const convertNode = (node: ConvertNode): CustomNode | undefined => {
                if (node.QuestionText !== undefined) {
                    const answers = ((node.Children as (ConvertNode & AnswerNode)[]) || []).filter(i => i != null).map(child => new CQAnswerNode(child.DbId, child.AnswerText, child.HelpText, child.Children != null && child.Children.some(i => i != null) ? convertNode(child.Children.find(i => i != null) as ConvertNode) : undefined));
                    return new CQQuestionNode(node.DbId || node.Id, node.Tenant || tenant.value, node.QuestionText, answers);
                } else if (node.LinkedId !== undefined) {
                    const linkArray = otherTenantQuestions.value.filter(i => i.id == node.LinkedId && i.tenant == node.Tenant) as CQQuestionNode[];
                    return new CQLinkedQuestionNode(node.DbId || node.Id, linkArray.length > 0 ? linkArray[0] : undefined);
                } else if (node.FormName !== undefined) {
                    return new CQFormNode(node.DbId || node.Id, node.FormName, node.FormVersion, node.FormTenant, node.FormTypes as "link"[] | undefined, node.Label, node.Description, node.Tags);
                } else {
                    debugger;
                }
            };
            availablePages.value = homepageData.Forms.map(convertNode).sort((a: FormNodeTS, b: FormNodeTS) => (a.label ?? "").localeCompare(b.label ?? ""));
            otherTenantQuestions.value = homepageData.OtherTenantQuestions.map(convertNode) as CQQuestionNode[];
            rootNode.value = convertNode(homepageData.RootNode);
            // rootNode.value!.component = instance;
            loadedD.value = true;
        };
        const canRemoveAnswer = (answer: CustomNode) => {
            return (answer.parent as CQQuestionNode).answers.length > 2;
        };
        const clickNode = (node: CustomNode, type: string) => {
            if (node instanceof CQActionTemplateNode) {
                const replacementNode = type == "newQuestion" ? new CQQuestionNode() : type == "newLinkedQuestion" ? new CQLinkedQuestionNode() : type == "newForm" ? new CQFormNode() : null;
                replacementNode!.parent = node.parent;
                (node.parent as CQAnswerNode).answerNext = replacementNode!;
                currentEditNode.value = replacementNode;
                instance.$forceUpdate(); // Not sure why this isn't being detected
            } else if (node instanceof CQAnswerNode) {
                currentEditNode.value = node.parent;
            } else {
                currentEditNode.value = node;
            }
        };
        const isTagEnabled = (tag: string) => {
            return filteredPages.value.some(i => i.tags.includes(tag));
        };
        //hasSearchTag(tag) {
        //    return selectedTags.value.includes(tag);
        //},
        const hasSearchTenant = (tenant: string) => {
            return selectedTenants.value.includes(tenant);
        };
        //toggleSearchTag(tag) {
        //    if (hasSearchTag.value(tag)) { // TODO library function for toggling?
        //        selectedTags.value = selectedTags.value.filter(i => i != tag);
        //    } else {
        //        selectedTags.value.push(tag);
        //    }
        //},
        const toggleSearchTenant = (tenant: string) => {
            if (hasSearchTenant(tenant)) {
                // TODO library function for toggling?
                selectedTenants.value = selectedTenants.value.filter(i => i != tenant);
            } else {
                selectedTenants.value.push(tenant);
            }
        };
        //searchForms() {
        //    searchFormsText.value = searchFormsTextInput.value;
        //},
        //changeTab(tab) {
        //    tab.value = tab;
        //},
        const changeMainTab = (newTab: string) => {
            mainTab.value = newTab;
        };
        const stopEditing = () => {
            currentEditNode.value = null;
        };
        const addAnswer = () => {
            const newAnswer = new CQAnswerNode();
            newAnswer.parent = currentEditNode.value;
            (currentEditNode.value as CQQuestionNode).answers.push(newAnswer);
        };
        const removeAnswer = (answer: CustomNode) => {
            if (canRemoveAnswer(answer)) {
                (currentEditNode.value as CQQuestionNode).answers = (currentEditNode.value as CQQuestionNode).answers.filter((i: CustomNode) => i != answer);
            }
        };
        const setForm = (form: FormListItem) => {
            (currentEditNode.value as CQFormNode).setForm(form);
            //stopEditing.value();
        };
        const setLinkedQuestion = (question: CQQuestionNode) => {
            (currentEditNode.value as CQLinkedQuestionNode).setLinkedQuestion(question);
            //stopEditing.value();
        };
        const changeToQuestion = () => {
            const parent = currentEditNode.value!.parent as CQAnswerNode;
            var newQuestion = new CQQuestionNode();
            newQuestion.parent = parent;
            parent.answerNext = newQuestion;
            currentEditNode.value = newQuestion;
            instance.$forceUpdate(); // Not sure why this isn't being detected
        };
        const changeToForm = () => {
            if (canChangeToForm.value) {
                if (!(currentEditNode.value instanceof CQQuestionNode) || confirm("Are you sure you want to convert this question into a link?")) {
                    const parent = currentEditNode.value!.parent as CQAnswerNode;
                    var newForm = new CQFormNode();
                    newForm.parent = parent;
                    parent.answerNext = newForm;
                    currentEditNode.value = newForm;
                    instance.$forceUpdate(); // Not sure why this isn't being detected
                }
            }
        };
        const changeToQuestionLink = () => {
            if (canChangeToQuestionLink.value) {
                if (!(currentEditNode.value instanceof CQQuestionNode) || confirm("Are you sure you want to convert this question into a question link?")) {
                    const parent = currentEditNode.value!.parent as CQAnswerNode;
                    var newQuestionLink = new CQLinkedQuestionNode();
                    newQuestionLink.parent = parent;
                    parent.answerNext = newQuestionLink;
                    currentEditNode.value = newQuestionLink;
                    instance.$forceUpdate(); // Not sure why this isn't being detected
                }
            }
        };
        const saveAndExit = async () => {
            if (savePromise.value) {
                emit("change-page", { page: "Admin" });
            }
        };
        const save = async () => {
            return await (savePromise.value = (async () => {
                const type = mainTab.value == "home-content" ? "home" : "gq";
                const urlType = type == "home" ? "adminGuidedSearchSaveLandingContent" : type == "gq" ? "adminGuidedSearchSaveV3" : "adminGuidedSearchSaveV2";
                const saveUrl = await mainStore.getUrl(urlType, { areaCode: props.settings.areaCode, areaUrlSlug: props.settings.areaUrlSlug });
                const formData = new FormData();
                if (type == "home") {
                    if (landingPageHtml.value != null) {
                        formData.append("landingPageHtml", landingPageHtml.value);
                    }
                }
                if (type == "gq") {
                    const rootNodeSave = rootNode.value!.convertToSaveStruct("rootNode");
                    rootNodeSave.forEach(v => {
                        if (v.value != null) {
                            formData.append(v.key, v.value);
                        }
                    });
                }
                const saveResponse = await fetch(saveUrl, {
                    method: "POST",
                    credentials: "same-origin",
                    headers: await getXsftHeader(mainStore),
                    body: formData,
                });
                throwIfNonSuccessStatus(saveResponse);
                const saveJson = await saveResponse.json();
                if (!saveJson.Success) {
                    throw saveJson.Errors || ["Unknown error occurred"];
                }
            })());
        };

        onBeforeMount(async () => {
            await init();
        });
        onActivated(async () => {
            document.getElementsByTagName("body")[0].classList.add("no-footer");
            if (isInitialCreate.value) {
                isInitialCreate.value = false;
            } else {
                await init();
            }
        });
        onDeactivated(() => {
            document.getElementsByTagName("body")[0].classList.remove("no-footer");
        });

        return {
            // States
            isInitialCreate,
            loadedD,
            loadedR,
            loadedS,
            loadedT,
            landingPageHtml,
            otherTenantQuestions,
            rootNode,
            availablePages,
            canEdit,
            mainTab,
            tab,
            showLegend,
            currentEditNode,
            selectedTags,
            selectedTenants,
            searchFormsTextInput,
            searchFormsText,
            savePromise,
            rapUrl,
            treUrl,

            // Async Computed
            adminUrl,
            adminPageIndexUrl,

            // Computed
            loaded,
            containerId,
            rootUrlPromise,
            tenant,
            hasOtherTenantQuestions,
            allowableTags,
            allowableTenants,
            currentlyEditing,
            isEditingQuestion,
            isEditingForm,
            isEditingLinkedQuestion,
            canChangeToForm,
            canChangeToQuestionLink,
            filteredPages,
            isValid,

            // Methods
            canRemoveAnswer,
            clickNode,
            isTagEnabled,
            hasSearchTenant,
            toggleSearchTenant,
            changeMainTab,
            stopEditing,
            addAnswer,
            removeAnswer,
            setForm,
            setLinkedQuestion,
            changeToQuestion,
            changeToForm,
            changeToQuestionLink,
            saveAndExit,
            save,

            // Vue-tsc workarounds
            //eslint-disable-next-line @typescript-eslint/no-explicit-any
            cqFormNodeCast: (i: any) => i as CQFormNode,
            //eslint-disable-next-line @typescript-eslint/no-explicit-any
            cqQuestionNodeCast: (i: any) => i as CQQuestionNode,
            //eslint-disable-next-line @typescript-eslint/no-explicit-any
            cqLinkedQuestionNodeCast: (i: any) => i as CQLinkedQuestionNode,
        };
    },
    components: {
        Promised,
        TenantDisplay,
        DfTinyMceEditor,
        AsyncOperationStatus,
        LoadingPlaceholder,
    },
    directives: {
        treant: {
            mounted: function (element, binding) {
                applyChanges(element, binding);
            },
            updated: function (element, binding) {
                const action = function () {
                    const chartId = element.dataset.chartId;
                    const chartObj = treantData[chartId];
                    // @ts-expect-error
                    window.TreeStore.destroy(chartObj.id);
                    applyChanges(element, binding);
                };
                let oldId = element.dataset.refreshId;
                if (oldId) {
                    clearTimeout(oldId);
                }
                oldId = setTimeout(action);
                element.dataset.refreshId = oldId;
            },
            unmounted: function (element, _binding) {
                const chartId = element.dataset.chartId;
                const chartObj = treantData[chartId];
                // @ts-expect-error
                window.TreeStore.destroy(chartObj.id);
                delete treantData[chartId];
            },
        },
    },
});
</script>
